import { render, staticRenderFns } from "./SfComponentSelectOption.vue?vue&type=template&id=fa5e08fe"
import script from "./SfComponentSelectOption.vue?vue&type=script&lang=js"
export * from "./SfComponentSelectOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "6e363ea2"
  
)

export default component.exports